import each from 'lodash/each';

export default function tagCurrentMenuItems() {
    each(document.querySelectorAll('.menu .menu-item'), (menuItem) => {
        each(menuItem.querySelectorAll('a'), (a) => {
            if (location.href.indexOf(a.href) !== -1) {
                menuItem.classList.add('menu-item-current');
            }
        });
    });
}
